var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }